module.exports = __webpack_public_path__ + "static/apple_cs-cd833a14725835773557b60de8f2844d.png";